export default __webpack_public_path__ + "static/media/advice.3e5a50af.png";